import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-foreground-500 transition-colors hover:text-primary-600"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'font-medium text-foreground-900' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </span>
        );
      })}
    </nav>
  );
}